/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import SearchInput from "../../components/searchInput";
import MyAppointmentList from "../../containers/MyAppointmentList";
import ICDateInput from "../../components/form/dateInput";
import ICCheckbox from "../../components/form/checkbox";

class MyAppointmentsPage extends Component {
  constructor() {
    super();
    this.state = {
      openAppointmentSearch: "",
      todaysBooking: true
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  
  onSignUpFormSubmit = formValues => {
    console.log("Sign up form submitted : ", formValues);
    this.setState({ form1Filled: true, form2Active: true });
  };

  render() {
    return (
      <div className="row rounded p-3 open-appointment-page">
        {/* Top Filters */}
        <div className="col-sm-12 p-3">
          <Label title="My Appointments" className="big" />
        </div>
        <div className="col-sm-7 pl-0">
          <div className="custom-chk-lbl ml-3 float-left">
            <ICCheckbox
              name="todaysBooking"
              onChange={val => {
                this.setState({
                  todaysBooking: !this.state.todaysBooking
                });
              }}
              value={this.state.todaysBooking}
              inputProps={{
                "aria-label": "Today's Bookings"
              }}
              label="Today's Bookings"
            />
          </div>
          <div className="w-auto float-left pt-2">
            <ICDateInput
              id="startdate"
              className="cal-primary-bg"
              label=""
              defaultDate={this.state.todaysBooking}
              handleChange={date => console.log(date)}
            />
          </div>
        </div>
        <div className="col-sm-4 offset-sm-1 pt-1 ">
          <SearchInput
            id="postcode"
            name="postcode"
            onChange={e =>
              this.setState({ openAppointmentSearch: e.target.value })
            }
            value={this.state.openAppointmentSearch}
            className="w-100 font-14"
            placeholder="Search"
          />
        </div>
        <div className="col-sm-12 border-bottom pt-3"></div>

        <div className="col-sm-12 mt-5">
          <MyAppointmentList backNav={this.state.from} />
        </div>
      </div>
    );
  }
}

export default MyAppointmentsPage;
